import { reactive, toRefs, ref } from 'vue'
import { PLATFORM } from '@/common/js/constants.js'
import { BRAND_LIST, BRAND_ENUM } from '../../../../model/creative-const.js'

const currentModifyTableRow = ref({})
const tableData = ref([])

const defaultLandingPages = {
  text: '未配置',
  info: []
}

const iosDefaultLandingPage = {
  text: '已配置',
  info: [
    {
      page: {},
      pageType: 3
    }
  ]
}
const miniGameDefaultLandingPage = {
  text: '已配置',
  info: [
    {
      page: {},
      pageType: 4
    }
  ]
}

export const useTable = (configForm, updateConfigForm) => {
  function initPagesTable(accounts = []) {
    tableData.value = []
    accounts.forEach((ac) => {
      const item = configForm.value.landingPages.find((i) => i.accountId === ac.id)
      const { planForm, creativeForm } = configForm.value
      const { ch_platform_id } = planForm
      const { social_skill } = creativeForm?.components || {}

      let landingPages = defaultLandingPages
      if (ch_platform_id === PLATFORM.IOS) {
        landingPages = iosDefaultLandingPage
      }
      if (ch_platform_id === PLATFORM.MINI_PROGRAM) {
        landingPages = miniGameDefaultLandingPage
      }

      const row = {
        // plan, creative 给弹窗组件填充必要参数 src/views/create/gdt/components/distribute/components/ad-profile.vue
        plan: { ...planForm, account: { id: ac.id } },
        creative: creativeForm,
        accountId: ac.id,
        accountName: ac.adAccount,

        profile: {
          text: '未配置',
          info: {}
        },
        landingPages
      }

      if (item) {
        const { social_skill_first_comment_switch } = social_skill || {}
        const { brandType } = item.profile || {}
        // 开启了首评回复后只能选择视频号、公众号，已经选了其他品牌形象的需要清空
        if (social_skill_first_comment_switch) {
          if ([BRAND_ENUM.CHANNEL, BRAND_ENUM.OFFICIAL_ACCOUNT].includes(brandType)) {
            // 只有当前配置的是视频号、公众号才赋值，否则使用默认空的配置
            row.profile = item.profile
          }
        } else {
          row.profile = item.profile
        }

        row.landingPages = item.landingPages
      }
      tableData.value.push(row)
    })

    updateConfigForm({
      ...configForm.value,
      landingPages: tableData.value
    })
  }

  return {
    tableData,
    currentModifyTableRow,
    initPagesTable
  }
}

export const useProfile = (configForm, updateConfigForm) => {
  const profileModel = reactive({
    showGlobalProfileModify: false
  })

  function onProfileSelect(row) {
    profileModel.showGlobalProfileModify = true
    currentModifyTableRow.value = row
  }

  function onProfileModifyConfirm(e, brandType) {
    let text = BRAND_LIST.find((i) => i.value === brandType).label + ':'
    if (brandType === BRAND_ENUM.PROFILE) {
      text += e.profile_name
    }
    if (brandType === BRAND_ENUM.BRAND) {
      text += e.name
    }
    if (brandType === BRAND_ENUM.CHANNEL) {
      text += e.promoted_object_name
    }
    if (brandType === BRAND_ENUM.OFFICIAL_ACCOUNT) {
      text += e.promoted_object_name
    }

    tableData.value = tableData.value.map((item) => {
      if (item.accountId === currentModifyTableRow.value.accountId) {
        return {
          ...item,
          profile: {
            ...item.profile,
            brandType,
            text: text || '未配置',
            info: e
          }
        }
      }
      return item
    })

    updateConfigForm({
      ...configForm.value,
      landingPages: tableData.value
    })
    profileModel.showGlobalProfileModify = false
  }

  return {
    ...toRefs(profileModel),
    currentModifyTableRow,
    onProfileModifyConfirm,
    onProfileSelect
  }
}

export const useLandingPages = (configForm, updateConfigForm) => {
  const pagesModel = reactive({
    showGlobalPagesModify: false
  })

  function onLandingPageSelect(row) {
    pagesModel.showGlobalPagesModify = true
    currentModifyTableRow.value = row
  }

  function onPageModifyConfirm(e) {
    tableData.value = tableData.value.map((item) => {
      if (item.accountId === currentModifyTableRow.value.accountId) {
        return {
          ...item,
          landingPages: {
            ...item.landingPages,
            text: e?.length ? '已配置' : '未配置',
            info: e
          }
        }
      }
      return item
    })

    updateConfigForm({
      ...configForm.value,
      landingPages: tableData.value
    })
    pagesModel.showGlobalPagesModify = false
  }

  return {
    ...toRefs(pagesModel),
    onLandingPageSelect,
    onPageModifyConfirm
  }
}
